export class BoxCollider {
    private _left: number;
    private _right: number;
    private _top: number;
    private _bottom: number;

    constructor(pLeft: number = 0, pRight: number = 0, pTop: number = 0, pBottom: number = 0) {
        this._left = pLeft;
        this._right = pRight;
        this._top = pTop;
        this._bottom = pBottom;
    }

    public static fromSprite(pSprite: PIXI.Sprite): BoxCollider {
        return new BoxCollider(
            -pSprite.width * pSprite.anchor.x,
            pSprite.width * (1 - pSprite.anchor.x),
            -pSprite.height * pSprite.anchor.y,
            pSprite.height * (1 - pSprite.anchor.y),
        );
    }

    public get left(): number {
        return this._left;
    }

    public set left(pValue: number) {
        this._left = pValue;
    }

    public get right(): number {
        return this._right;
    }

    public set right(pValue: number) {
        this._right = pValue;
    }

    public get top(): number {
        return this._top;
    }

    public set top(pValue: number) {
        this._top = pValue;
    }

    public get bottom(): number {
        return this._bottom;
    }

    public set bottom(pValue: number) {
        this._bottom = pValue;
    }

    public offset(pOffset: PIXI.Point): BoxCollider {
        this._left += pOffset.x;
        this._right += pOffset.x;
        this._top += pOffset.y;
        this._bottom += pOffset.y;
        return this;
    }

    public copy(pBox: BoxCollider): BoxCollider {
        this._left = pBox.left;
        this._right = pBox.right;
        this._top = pBox.top;
        this._bottom = pBox.bottom;
        return this;
    }
}
